import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomCancelAiMappingTaskMutation } from "generated/graphql";

export const useCancelAiMappingTask = () => {
  const [mutation, { data, loading, error }] = useCustomCancelAiMappingTaskMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "cancelAiMappingTask" },
    { hideMessage: true }
  );
};
